import { applyMiddleware, compose, createStore } from 'redux'
import reducers from '../app/reducers'

let appStore = null

// adds action.globalState() function to retrieve global redux state from tree
function globalState({ getState }) {
  return next => action => {
    next({ ...action, getGlobaState: getState })
  }
}

export function getStore() {
  return appStore
}

export default (initialState = {}) => {
  let middleware = applyMiddleware(globalState)

  const store = createStore(reducers(), initialState, middleware)

  store.asyncReducers = {}
  appStore = store

  return store
}
